import useQuery from "./useQuery";

export type ActivityEventFilterItem =
  | {
      type: "FAULT_EVENT";
      id: {
        faultEventId: string;
        faultEventProjectId: string;
        faultEventFailureName: string;
        faultEventStartsAt: string;
      };
      name: string | null;
    }
  | {
      type: "MANUAL_FAULT_EVENT";
      id: {
        manualFaultEventId: string;
      };
      name: string | null;
    };

export const useActivityEvents = (projectId?: string | undefined) => {
  const events = useQuery("/activities/events", {
    query: projectId ? { projectId } : {},
  }).body;

  return events;
};
